// Styles
import './featured-articles.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initFeaturedArticles = (context) => {
  const featuredArticlesSection = context.closest('.shopify-section');
  if (!featuredArticlesSection) return;
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.featured-articles__container'), (el) => {
    window.dAgency.initFeaturedArticles(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.featured-articles__container'), (el) => {
      window.dAgency.initFeaturedArticles(el);
    });
  });
}
